// @flow

import React, {createContext, useMemo, useState} from 'react';

import type {Node} from 'react';

type CustomAdditionalInformationData = {
  value: string[],
  error?: string,
};

export type AdditionalInformationData = {
  additionalInformation: {
    [key: string]: CustomAdditionalInformationData,
  },
  setAdditionalInformation: (
    | CustomAdditionalInformationData
    | ((
        prev: CustomAdditionalInformationData
      ) => CustomAdditionalInformationData)
  ) => void,
  additionalIformationValidate: boolean,
  setAdditionalInformationValidate: (value: boolean) => void,
};

export const AdditionalInformationContext = createContext<AdditionalInformationData>(
  {}
);

type AddInfoProviderProps = {
  children: Node,
};

export const AdditionalInformationProvider = (props: AddInfoProviderProps) => {
  const {children} = props;

  const [additionalInformation, setAdditionalInformation] = useState<{}>({});

  const [
    additionalIformationValidate,
    setAdditionalInformationValidate,
  ] = useState<boolean>(false);

  const contextValues = useMemo(() => {
    return {
      additionalInformation,
      setAdditionalInformation,
      additionalIformationValidate,
      setAdditionalInformationValidate,
    };
  }, [additionalIformationValidate, additionalInformation]);

  return (
    <AdditionalInformationContext.Provider value={contextValues}>
      {children}
    </AdditionalInformationContext.Provider>
  );
};
